module.exports = __webpack_public_path__ + "static/img/logoMAC_kolor.1943bcd9.png";